<template>
  <aside class="rgt" :class="heightSize">
    <!-- 검색 .on 클래스로 활성 -->
    <div class="hd_search on">
      <a class="sch_btn" @click="setSearchVisible" onclick="gtag('event', '버튼클릭', {'event_category': 'GNB','event_label': '통합검색',  'non_interaction': true});">검색하기</a>
      <div class="sch_box">
        <input type="text" placeholder="Search" :disabled="tagVisible" v-model.trim="keyword" ref="keyword" @keyup.enter="setSearchVisible" @click="setKeywordHide">

        <!-- 검색창 고정 키워드 태그 line 132~134 -->
        <q-chip clickable removable v-model="tagVisible" class="tag" text-color="white" @click="clickKeywordTag('DA@카드의 정석')">DA@카드의 정석</q-chip>
      </div>
    </div>
  </aside>
</template>

<script>
  import Vue from 'vue'
  import {QCarousel, QCarouselControl, QCarouselSlide, QChip} from 'quasar'
  import {Dialog, Popover, Dropdown, DropdownMenu, DropdownItem} from 'element-ui'
  import CommonComputed from 'src/_mixins/CommonComputed'
  import CommonMethods from 'src/_mixins/CommonMethods'
  const keyword = ''
  export default {
    name: 'HeaderSearchArea',
    components: {
      QCarousel, QCarouselControl, QCarouselSlide, QChip,
      [Dialog.name]: Dialog,
      [Popover.name]: Popover,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
    },
    props: {
      fixed: {
        default: false,
        type: Boolean
      },
      topOffset: {
        default: 200,
        type: Number
      },
      heightSize: {
        default: '',
        type: String
      }
    },
    data () {
      return {
        env: 'pc',
        dropdown: {
          search: false,
          ranking: false
        },
        slide: 1,
        keyword: keyword,
        searchVisible: true,
        loaded: false,
        tagVisible: false
      }
    },
    created () {
      window.addEventListener('scroll', this.handleScroll);
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll);
    },
    watch: {
      '$route' (to, from) {
        if (to.name !== 'SearchAll') {
          this.searchVisible = false
          this.keyword = keyword
        }
      }
    },
    computed: {
      ...CommonComputed,
      getQueryKeyword () {
        return this.$route.query.keyword ? this.$route.query.keyword : keyword ? keyword : ''
      },
    },
    methods: {
      ...CommonMethods,
      isCurrentGNB (name) {
        return this.$route.path.indexOf(name) > -1
      },
      isCurrentRouteParamsView (name) {
        return this.$route.params.view === name
      },
      isCurrentRouteName (name) {
        return this.$route.name === name
      },
      setSearchVisible () {
        if (this.keyword.trim() !== '') {
          this.$router.push({path: `/article/search/${this.keyword}`})
        }
      },
			setKeywordHide () {
				this.keyword = ''
			},
      openSearchMenuDropdown () {
        this.dropdown.search = true
        this.dropdown.ranking = false
      },
      openRankingDropdown () {
        this.dropdown.search = false
        this.dropdown.ranking = true
      },
      closeDropdown () {
        this.dropdown.search = false
        this.dropdown.ranking = false
      },
      outside (e) {
        // console.log('out')
        if (this.dropdown.search) {
          return this.dropdown.search =  false
        } else if (this.dropdown.ranking) {
          return this.dropdown.ranking = false
        }
      },
      clickKeywordTag (tag) {
        this.tagVisible = false
        this.keyword = tag
        this.setSearchVisible()
      }
    },
    directives: {
      'click-outside': {
        bind: function (el, binding, vNode) {
          // Provided expression must evaluate to a function.
          if (typeof binding.value !== 'function') {
            const compName = vNode.context.name
            let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
            if (compName) {
              warn += `Found in component '${compName}'`
            }
            console.warn(warn)
          }
          // Define Handler and cache it on the element
          const bubble = binding.modifiers.bubble
          const handler = (e) => {
            if (bubble || (!el.contains(e.target) && el !== e.target)) {
              binding.value(e)
            }
          }
          el.__vueClickOutside__ = handler

          // add Event Listeners
          document.addEventListener('click', handler)
        },

        unbind: function (el, binding) {
          // Remove Event Listeners
          document.removeEventListener('click', el.__vueClickOutside__)
          el.__vueClickOutside__ = null
        }
      }
    }
  }
</script>

<style scoped>
  .rgt:after {
    display: block;
    clear: both;
    content: "";
  }
  .hd_search {
    float: left;
    position: relative;
    z-index: 2;
  }
  .hd_search .sch_btn {
    display: block;
    width: 60px;
    height: 60px;
    font-size: 0;
    text-indent: -9999px;
    transition: all 0.2s;
    cursor: pointer;
    background: url('/statics/img/hd_search_icon_white.png') no-repeat center center;
  }
  .hd_search .sch_box {
    position: absolute;
    left: -130px;
    top: 0;
    width: 150px;
    height: 60px;
  }
  .hd_search .sch_box input {
    width: 100%;
    height: 60px;
    padding: 0 20px;
    font-size: 16px;
    color: #00ff64;
    border: 0;
  }
  .hd_search .sch_box input:disabled {
    background: #222 !important;
  }
  .hd_search .sch_box input::-webkit-input-placeholder {
    color: #777;
    font-weight: 500;
  }
  .hd_search .sch_box input:-moz-placeholder {
    color: #777;
  }
  .hd_search .sch_box input::-moz-placeholder {
    color: #777;
  }
  .hd_search .sch_box input:-ms-input-placeholder {
    color: #777;
  }
  .hd_search .sch_box .tag {
    position: absolute;
    left: 7px;
    top: 22px;
    background: #222;
    font-weight: 500;
    cursor: pointer;
  }
  /deep/ .hd_search .sch_box .tag .q-chip__icon--remove {
    margin-left: 0.5em;
  }

  .small .hd_slide,
  .small .hd_slide .open,
  .small .slide_lst a p,
  .small .live_ranking .tit,
  .small .hd_search .sch_btn,
  .small .hd_search .sch_box,
  .small .hd_search .sch_box input {
    height: 60px;
  }
  .small .hd_search .sch_box .tag {
    top: 11px;
  }
  .bi_sch .hd_search .sch_btn {
    width: 60px;
    height: 60px;
    background: url('/statics/img/hd_search_icon_white.png') no-repeat center center;
    filter: none;
  }
  .bi_sch .hd_search .sch_box {
    width: 240px;
    left: -240px;
    height: 40px;
    padding: 10px 0;
  }
  .bi_sch .hd_search .sch_box input {
    height: 40px;
    font-style: normal;
    color: #fff;
    background: rgba(255,255,255,0.2);
  }
</style>
